import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that automatically tracks page views with Plausible Analytics
 * Place this component inside your router to track all page changes
 */
const PageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    if (window.plausible) {
      window.plausible('pageview');
    }
  }, [location.pathname, location.search]);

  return null; // This component doesn't render anything
};

export default PageTracker; 